import React, {useState} from 'react';
import $api from "../http";
import "../css/main-admin.css"
import {addDevidersToString} from "./helpers/helper-functions";
import ModalDialog from "./ModalDialog";

const MainAdminTools = ({merchants, traders}) => {



    const [isProcessing, setIsProcessing] = useState(false)
    const [wrongAccountedOrders, setWrongAccountedOrders] = useState([])
    const [sumOfWrongs, setSumOfWrongs] = useState(0)

    const [stateOfResult, setStateOfResult] = useState("Waiting")


    const [currentMerchantId, setCurrentMerchantId] = useState()
    const [currentMerchantProfit, setCurrentMerchantProfit] = useState(0)

    const [trader, setTrader] = useState("")
    const [expectedBalance, setExpectedBalance] = useState(0)
    const [traderFinanceData, setTraderFinanceData] = useState("")


    const [orderIdToCancel, setOrderIdToCancel] = useState()
    const [orderIdToCompensation, setOrderIdToCompensation] = useState()
    const [activeRollbackModal, setActiveRollbackModal] = useState("no")
    const [activeCompensationModal, setActiveCompensationModal] = useState("no")
    const [modalMessage, setModalMessage] = useState("")
    const [cancelledInfo, setCancelledInfo] = useState("")
    const [compensatedInfo, setCompensatedInfo] = useState("")


    const [balanceMove, setBalanceMove] = useState({})
    const [activeBalanceMoveModal, setActiveBalanceMoveModal] = useState("no")
    const [moveResult, setMoveResult] = useState("")


    const [balanceChange, setBalanceChange] = useState({})
    const [activeBalanceChangeModal, setActiveBalanceChangeModal] = useState("no")
    const [changeResult, setChangeResult] = useState("")


    const [hashToBlock, setHashToBlock] = useState("")
    const [blockResult, setBlockResult] = useState("")



    const blockHash = async (hashToBlock) => {

        const response = await $api.get(`/block_hash?hashToBlock=${hashToBlock}`)

        console.log(response.data)

        if(response.data.result === "FAIL") {
            setModalMessage(response.data.message)
            setActiveBalanceChangeModal("progress")
            setTimeout(() => {
                setActiveBalanceChangeModal("active")
            }, 300)
        } else {

            setHashToBlock("")
            setBlockResult("OK")

            setTimeout(() => {
                setBlockResult("")
            }, 2000)

        }

    }


    const changeBalanceStart = async (balanceChange) => {


        const response = await $api.post('/balance_change', {balanceChange})

        console.log(response.data)

        if(response.data.result === "FAIL") {
            setModalMessage(response.data.message)
            setActiveBalanceChangeModal("progress")
            setTimeout(() => {
                setActiveBalanceChangeModal("active")
            }, 300)
        } else {

            setBalanceChange({user: "", value: "", direction: balanceChange.direction, description: ""})
            setChangeResult("OK")

            setTimeout(() => {
                setChangeResult("")
            }, 2000)

        }


    }


    const moveBalanceStart = async (balanceMove) => {


        const response = await $api.post('/balance_move', {balanceMove})

        console.log(response.data)

        if(response.data.result === "FAIL") {
            setModalMessage(response.data.message)
            setActiveBalanceMoveModal("progress")
            setTimeout(() => {
                setActiveBalanceMoveModal("active")
            }, 300)

        } else {

            setBalanceMove({from: "", to: "", value: ""})
            setMoveResult("OK")

            setTimeout(() => {
                setMoveResult("")
            }, 2000)

        }


    }



    const cancelOrderPhaseOne = async (orderId, purpose) => {


        try {



            const response = await $api.get(`/get_info_for_cancel?orderId=${orderId}`)

            if(response.data?.result === "OK") {


                const orderData = response.data.orderData

                setModalMessage(
                    `${purpose} заказ #${orderData.number}?\nТрейдер: ${orderData.trader}\nМерчант: ${orderData.merchant}\nНа сумму: ${orderData.amount}`
                )


                if(purpose === "Откатываем") {

                    console.log("ОТКРЫВАЕМ МОДАЛКУ ОТКАТА")


                    setActiveRollbackModal("progress")
                    setTimeout(() => {
                        setActiveRollbackModal("active")
                    }, 300)
                } else {

                    console.log("ОТКРЫВАЕМ МОДАЛКУ КОМПЕНСАЦИИ")

                    setActiveCompensationModal("progress")
                    setTimeout(() => {
                        setActiveCompensationModal("active")
                    }, 300)
                }



            } else {

                setModalMessage(response.data.message)

                if(purpose === "Откатываем") {
                    setActiveRollbackModal("progress")
                    setTimeout(() => {
                        setActiveRollbackModal("active")
                    }, 300)
                } else {
                    setActiveCompensationModal("progress")
                    setTimeout(() => {
                        setActiveCompensationModal("active")
                    }, 300)
                }



            }

        } catch (e) {

            setModalMessage(e.message)

            if(purpose === "Откатываем") {
                setActiveRollbackModal("progress")
                setTimeout(() => {
                    setActiveRollbackModal("active")
                }, 300)
            } else {
                setActiveCompensationModal("progress")
                setTimeout(() => {
                    setActiveCompensationModal("active")
                }, 300)
            }


        }




    }

    const cancelOrderPhaseTwo = async (orderId, rollback) => {

        try {


            if(rollback) {



                const response = await $api.get(`/rollback_order?orderId=${orderId}`)


                console.log(response.data)

                if(response.data?.result === "OK") {


                    setOrderIdToCancel("")

                    const orderData = response.data.cancelledData

                    setCancelledInfo(orderData)


                } else {

                    setActiveRollbackModal("progress")
                    setTimeout(() => {
                        setActiveRollbackModal("active")
                    }, 300)

                    setModalMessage(response.data.message)

                }
            } else {

                console.log("РЕЖИМ КОМПЕНСАЦИИ")


                const response = await $api.get(`/compensate_order?orderId=${orderId}`)


                console.log(response.data)

                if(response.data?.result === "OK") {


                    setOrderIdToCompensation("")

                    const orderData = response.data.cancelledData

                    setCompensatedInfo(orderData)


                } else {

                    setActiveRollbackModal("progress")
                    setTimeout(() => {
                        setActiveRollbackModal("active")
                    }, 300)

                    setModalMessage(response.data.message)

                }
            }





        } catch (e) {
            setActiveRollbackModal("progress")
            setTimeout(() => {
                setActiveRollbackModal("active")
            }, 300)

            setModalMessage(e.message)
        }

    }



    const checkTraderBalance = async (traderId) => {

        if(!traderId) return

        const response = await $api.get(`/check_trader_balance?traderId=${traderId}`)
        console.log(response.data)

        const traderData = response.data

        setTraderFinanceData(traderData)

        const expectations = traderData.topUpsTotalSum - (traderData.insurance + traderData.ordersTotalAmountSum)
        setExpectedBalance(expectations)

    }



    const fixWrongOrders = async (wrongAccountedOrders) => {

        setIsProcessing(true)
        setStateOfResult("Processing")

        const arrayOfId = wrongAccountedOrders.map(order => order._id.toString())

        try {

            const response = await $api.post('/fix_wrong_orders', {arrayOfId})

            if(response.data === "OK") {
                setStateOfResult("OK")
                setWrongAccountedOrders([])
                setSumOfWrongs(0)
                setTimeout(() => {
                    setStateOfResult("Waiting...")
                }, 3000)


            }

        } catch (e) {
            setStateOfResult("ERROR")
        }


        setIsProcessing(false)

    }


    const getWrongAccountedOrders = async () =>  {

        setIsProcessing(true)
        const response = await $api.get('/get_wrong_accounted_orders')
        console.log(response.data)

        const arrayOfWrongs = response.data


        if(!arrayOfWrongs.length) {
            setStateOfResult("Нет недостач")

            setTimeout(() => {
                setStateOfResult("Waiting...")
            }, 3000)

            return
        }


        setWrongAccountedOrders(arrayOfWrongs)
        const sumCalculation = arrayOfWrongs.reduce((acc, order) => {

            acc = order.amount + acc
            return acc

        }, 0)


        setSumOfWrongs(sumCalculation)
        setIsProcessing(false)
        setStateOfResult("Есть недостачи")


    }



    return (
        <div className={"main-admin-wrapper"}>


            <div className={"wrong-accounted-orders-wrapper"}>

                <h5 className={"main-admin-settings-label"}>Недорассчитанные заявки</h5>
                <h4 className={"main-admin-data-h"}>{stateOfResult}</h4>


                <button
                    onClick={() => getWrongAccountedOrders()}
                    className={"gradient-orange-button"}
                >
                    Проверить
                </button>

                <h4 className={"main-admin-data-h"}>{wrongAccountedOrders.length ? `${wrongAccountedOrders.length} недостач` : null}</h4>
                <h4 className={"main-admin-data-h"}>{wrongAccountedOrders.length ? `На сумму ${sumOfWrongs}` : null}</h4>
                {wrongAccountedOrders.length
                    ?
                    <button
                        onClick={() => fixWrongOrders(wrongAccountedOrders)}
                        className={"gradient-green-button"}
                    >
                        Пофиксить
                    </button>
                    :
                    null
                }

            </div>

            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Сверка баланса</h5>
                <h4 className={"main-admin-data-h"}>{stateOfResult}</h4>

                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>
                        <select
                            value={trader}
                            onChange={(e) => {

                                setTrader(e.target.value)

                            }}
                        >
                            <option value={""}>Выбрать...</option>
                            {Object.values(traders)
                                .sort((a, b) => a.login.localeCompare(b.login))
                                .map(trader => (
                                    <option key={trader.id} value={trader.id}>
                                        {trader.login}
                                    </option>
                                ))}

                        </select>

                        <button
                            onClick={() => checkTraderBalance(trader)}
                            className={"gradient-orange-button"}
                        >
                            Проверить
                        </button>
                    </div>

                    <div className={"admin-div-flex-column-container"}>
                        {traderFinanceData
                            ?
                            <>
                                <h5 className={"h-reset"}>{`Пополнения: ${addDevidersToString(traderFinanceData.topUpsTotalSum?.toFixed(2))} р.`}</h5>
                                <h5 className={"h-reset"}>{`Количество коррекций: ${addDevidersToString(traderFinanceData.corrections)}`}</h5>
                                <h5 className={"h-reset"}>{`Количество ордеров: ${traderFinanceData.ordersCount}`}</h5>
                                <h5 className={"h-reset"}>{`Сумма ордеров: ${addDevidersToString(traderFinanceData.ordersTotalAmountSum?.toFixed(2))} р.`}</h5>
                                <h5 className={"h-reset"}>{`Страховка: ${addDevidersToString(traderFinanceData.insurance?.toFixed(2))} р.`}</h5>
                                <h5 className={"h-reset"}>{`Фактический баланс: ${addDevidersToString(traderFinanceData.balance?.toFixed(2))} р.`}</h5>
                                <hr/>
                                <h5 className={"h-reset"}>{`Ожидаемый баланс: ${addDevidersToString(expectedBalance?.toFixed(2))} р.`}</h5>
                                <h5 className={"h-reset"}>{`Разбег: ${addDevidersToString((traderFinanceData.balance - expectedBalance)?.toFixed(2))} р.`}</h5>
                            </>
                            :
                            null
                        }

                    </div>

                </div>


            </div>

            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Откат заявки</h5>


                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>
                        <input
                            type={"text"}
                            value={orderIdToCancel}
                            onChange={(e) => setOrderIdToCancel(e.target.value)}
                        />
                        <button
                            onClick={() => cancelOrderPhaseOne(orderIdToCancel, "Откатываем")}
                            className={"gradient-orange-button"}
                        >
                            Откатить
                        </button>
                    </div>

                    <div className={"admin-div-flex-column-container"}>
                        {cancelledInfo
                            ?
                            <>
                                <h5 className={"h-reset"}>Заказ #{cancelledInfo.number} отменён</h5>
                                <h5 className={"h-reset"}>Мерчант: -{cancelledInfo.merchantProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Трейдер профит:
                                    -{cancelledInfo.traderProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Трейдер баланс: +{cancelledInfo.amount?.toFixed(2)}р.</h5>
                                <h5 className={"h-reset"}>Тимлид трейдера:
                                    -{cancelledInfo.teamleadTraderProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Тимлид мерчанта:
                                    -{cancelledInfo.teamleadMechantProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Платформа: -{cancelledInfo.platformProfit?.toFixed(2)}$</h5>
                            </>
                            :
                            null
                        }

                    </div>

                </div>


                <ModalDialog
                    active={activeRollbackModal}
                    setActive={setActiveRollbackModal}
                    purpose={"choice"}
                    message={modalMessage}
                    action={() => cancelOrderPhaseTwo(orderIdToCancel, true)}
                />

            </div>


            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Компенсация заявки</h5>


                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>
                        <input
                            type={"text"}
                            value={orderIdToCompensation}
                            onChange={(e) => setOrderIdToCompensation(e.target.value)}
                        />
                        <button
                            onClick={() => cancelOrderPhaseOne(orderIdToCompensation, "Компенсируем")}
                            className={"gradient-orange-button"}
                        >
                            Компенсировать
                        </button>
                    </div>

                    <div className={"admin-div-flex-column-container"}>
                        {compensatedInfo
                            ?
                            <>
                                <h5 className={"h-reset"}>Заказ #{compensatedInfo.number} компенсирован</h5>
                                <h5 className={"h-reset"}>Трейдер профит:
                                    -{compensatedInfo.traderProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Трейдер баланс: +{compensatedInfo.amount?.toFixed(2)}р.</h5>
                                <h5 className={"h-reset"}>Тимлид трейдера:
                                    -{compensatedInfo.teamleadTraderProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Тимлид мерчанта:
                                    -{compensatedInfo.teamleadMechantProfit?.toFixed(2)}$</h5>
                                <h5 className={"h-reset"}>Платформа: -{(compensatedInfo.platformProfit + compensatedInfo.merchantProfit)?.toFixed(2)}$</h5>
                            </>
                            :
                            null
                        }

                    </div>

                </div>


                <ModalDialog
                    active={activeCompensationModal}
                    setActive={setActiveCompensationModal}
                    purpose={"choice"}
                    message={modalMessage}
                    action={() => cancelOrderPhaseTwo(orderIdToCompensation, false)}
                />

            </div>


            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Перенос баланса</h5>


                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>

                        <select
                            value={balanceMove.from}
                            onChange={(e) => {

                                setBalanceMove(prev => {
                                    return {
                                        ...prev,
                                        from: e.target.value,
                                    }
                                })

                            }}
                        >
                            <option value={""}>Списать с...</option>
                            {Object.values(traders)
                                .sort((a, b) => a.login.localeCompare(b.login))
                                .map(trader => (
                                    <option key={trader.id} value={trader.id}>
                                        {trader.login}
                                    </option>
                                ))}

                        </select>
                        <select
                            value={balanceMove.to}
                            onChange={(e) => {

                                setBalanceMove(prev => {
                                    return {
                                        ...prev,
                                        to: e.target.value,
                                    }
                                })

                            }}
                        >
                            <option value={""}>Зачислить на...</option>
                            {Object.values(traders)
                                .sort((a, b) => a.login.localeCompare(b.login))
                                .map(trader => (
                                    <option key={trader.id} value={trader.id}>
                                        {trader.login}
                                    </option>
                                ))}

                        </select>
                        <input
                            type={"number"}
                            value={balanceMove.value}
                            placeholder={"Сумма"}
                            onChange={(e) => {

                                setBalanceMove(prev => {
                                    return {
                                        ...prev,
                                        value: e.target.value,
                                    }
                                })

                            }}
                        />

                        <button
                            onClick={() => moveBalanceStart(balanceMove)}
                            className={"gradient-orange-button"}
                        >
                            Перекинуть
                        </button>

                        <h5 className={"main-admin-data-h"}>{moveResult}</h5>
                    </div>
                </div>


                <ModalDialog
                    active={activeBalanceMoveModal}
                    setActive={setActiveBalanceMoveModal}
                    purpose={"info"}
                    message={modalMessage}
                    // action={() => cancelOrderPhaseTwo(orderIdToCancel)}
                />

            </div>


            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Изменение баланса трейдера</h5>


                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>

                        <select
                            // value={balanceChange.from}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        user: e.target.value,
                                        direction: "trader"
                                    }
                                })

                            }}
                        >
                            <option value={""}>Трейдер</option>
                            {Object.values(traders)
                                .sort((a, b) => a.login.localeCompare(b.login))
                                .map(trader => (
                                    <option key={trader.id} value={trader.id}>
                                        {trader.login}
                                    </option>
                                ))}

                        </select>

                        <input
                            type={"number"}
                            value={balanceChange.value}
                            placeholder={"Сумма Р."}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        value: e.target.value,
                                    }
                                })

                            }}
                        />

                        <input
                            type={"text"}
                            value={balanceChange.hash}
                            placeholder={"Хэш"}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        hash: e.target.value,
                                    }
                                })

                            }}
                        />

                        <button
                            onClick={() => changeBalanceStart(balanceChange)}
                            className={"gradient-orange-button"}
                        >
                            Изменить
                        </button>

                        {balanceChange.direction === "trader"
                            ? <h5 className={"main-admin-data-h"}>{changeResult}</h5>
                            : null
                        }
                    </div>
                </div>


                <ModalDialog
                    active={activeBalanceChangeModal}
                    setActive={setActiveBalanceChangeModal}
                    purpose={"info"}
                    message={modalMessage}
                    // action={() => cancelOrderPhaseTwo(orderIdToCancel)}
                />

            </div>


            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Изменение баланса мерча</h5>


                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>

                        <select
                            // value={balanceChange.from}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        user: e.target.value,
                                        direction: "merchant"
                                    }
                                })

                            }}
                        >
                            <option value={""}>Мерчант</option>
                            {Object.values(merchants)
                                .sort((a, b) => a.login.localeCompare(b.login))
                                .map(merchant => (
                                    <option key={merchant._id} value={merchant._id}>
                                        {merchant.login}
                                    </option>
                                ))}

                        </select>

                        <input
                            type={"number"}
                            value={balanceChange.value}
                            placeholder={"Сумма USDT"}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        value: e.target.value,
                                    }
                                })

                            }}
                        />

                        <input
                            type={"text"}
                            value={balanceChange.hash}
                            placeholder={"Хэш"}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        hash: e.target.value,
                                    }
                                })

                            }}
                        />

                        <input
                            type={"text"}
                            value={balanceChange.description}
                            placeholder={"Описание"}
                            onChange={(e) => {

                                setBalanceChange(prev => {
                                    return {
                                        ...prev,
                                        description: e.target.value,
                                    }
                                })

                            }}
                        />

                        <button
                            onClick={() => changeBalanceStart(balanceChange)}
                            className={"gradient-orange-button"}
                        >
                            Изменить
                        </button>

                        {balanceChange.direction === "merchant"
                            ? <h5 className={"main-admin-data-h"}>{changeResult}</h5>
                            : null
                        }
                    </div>
                </div>


                <ModalDialog
                    active={activeBalanceChangeModal}
                    setActive={setActiveBalanceChangeModal}
                    purpose={"info"}
                    message={modalMessage}
                    // action={() => cancelOrderPhaseTwo(orderIdToCancel)}
                />

            </div>


            <div className={"wrong-accounted-orders-wrapper"}>
                <h5 className={"main-admin-settings-label"}>Заблокировать транзакцию</h5>


                <div className={"admin-div-flex-row-container"}>
                    <div className={"admin-div-flex-column-container"}>

                        <input
                            type={"text"}
                            value={hashToBlock}
                            placeholder={"Хэш"}
                            onChange={(e) => {
                                setHashToBlock(e.target.value)
                            }}
                        />

                        <button
                            onClick={() => blockHash(hashToBlock)}
                            className={"gradient-orange-button"}
                        >
                            Заблокировать
                        </button>

                        <h5 className={"main-admin-data-h"}>{blockResult}</h5>
                    </div>
                </div>


            </div>

        </div>
    );
};

export default MainAdminTools;